var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1817_26171",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1817_26171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66536 16.6667H16.332C16.5681 16.6667 16.7661 16.7465 16.9258 16.9063C17.0855 17.066 17.1654 17.2639 17.1654 17.5C17.1654 17.7361 17.0855 17.934 16.9258 18.0938C16.7661 18.2535 16.5681 18.3333 16.332 18.3333H4.66536C4.42925 18.3333 4.23134 18.2535 4.07161 18.0938C3.91189 17.934 3.83203 17.7361 3.83203 17.5C3.83203 17.2639 3.91189 17.066 4.07161 16.9063C4.23134 16.7465 4.42925 16.6667 4.66536 16.6667ZM8.83203 15C8.59592 15 8.398 14.9201 8.23828 14.7604C8.07856 14.6007 7.9987 14.4028 7.9987 14.1667V9.16667H6.3737C6.02648 9.16667 5.77648 9.01042 5.6237 8.69792C5.47092 8.38542 5.4987 8.09028 5.70703 7.8125L9.83203 2.52083C9.91536 2.40972 10.0161 2.32639 10.1341 2.27083C10.2522 2.21528 10.3737 2.1875 10.4987 2.1875C10.6237 2.1875 10.7452 2.21528 10.8633 2.27083C10.9813 2.32639 11.082 2.40972 11.1654 2.52083L15.2904 7.8125C15.4987 8.09028 15.5265 8.38542 15.3737 8.69792C15.2209 9.01042 14.9709 9.16667 14.6237 9.16667H12.9987V14.1667C12.9987 14.4028 12.9188 14.6007 12.7591 14.7604C12.5994 14.9201 12.4015 15 12.1654 15H8.83203Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload2);
export default __webpack_public_path__ + "static/media/icon_upload_2.fd2fef343d3b2c94a95b01c84ce89db6.svg";
export { ForwardRef as ReactComponent };